import { Injectable } from "@angular/core"
import { SessionService } from "../app/services/session.service"


@Injectable({
  providedIn: 'root'
})
export class Global {
  masterdata: any;
  message: string = 'sateesh';
  constructor(_sessionservice: SessionService) {
    if (this.masterdata == null) {
      _sessionservice.getSessionDropdrownData().subscribe((res) => { this.masterdata = res; });
  }
  }
}
